import { Component, Input, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { ModalPreguntaFormuladaService } from "./modal-pregunta-formulada.service";

@Component({
  selector: "app-modal-pregunta-formulada",
  templateUrl: "./modal-pregunta-formulada.component.html",
  styleUrls: ["./modal-pregunta-formulada.component.scss"],
})

export class ModalPreguntaFormuladaComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  infoPregunta: any;
  clase_pregunta_id: any;
  pregunta_id: any;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];
  preguntaFormuladaCtrl = new FormControl();
  preguntaListaFiltrada: Observable<string[] | { value: number; name: string; }[]>;
  preguntaLista: any[] = [];

  modulos: any[] = [];
  preguntaListaTodas: any[] = this.modulos;

  isValid: boolean = false;
  isSyntaxisError: boolean = false;

  @ViewChild('preguntaFormuladaInput') preguntaFormuladaInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private activeModal: NgbActiveModal,
    private modalPreguntaFormuladaService: ModalPreguntaFormuladaService,
  ) {}

  ngOnInit() {
    this.modalGenerico = {
      titulo: '',
    };

    this.pregunta_id = this.clase_pregunta_id === 1 ?
      this.infoPregunta.pregunta_encuesta_id :
      this.infoPregunta.pregunta_adicional_encuesta_id;

    this.modalPreguntaFormuladaService
      .getModulosSeccionesPreguntas({
        anio: this.infoPregunta.anio,
        pregunta_id: this.pregunta_id,
        clase_pregunta_id: this.clase_pregunta_id,
        es_formula_o_condicion: true
      }).subscribe((resultado) => {
        if (resultado.data && resultado.data.length > 0) {
          this.modulos = resultado.data.reduce((acc, el) => {
            acc.push({
              id: el.modulo_encuesta_id,
              name: el.desc_modulo,
              value: null,
              isOperator: false
            });
            return acc;
          }, []);

          this.preguntaListaTodas = this.modulos;
          this.preguntaListaFiltrada = this.preguntaFormuladaCtrl.valueChanges.pipe(
            startWith(null),
            map((pregunta: string) => pregunta ? this._filter(pregunta) : this.preguntaListaTodas.slice()));
        }
      });

    this.modalPreguntaFormuladaService
      .getModulosSeccionesPreguntas({
        pregunta_encuesta_id: this.pregunta_id,
        clase_pregunta_id: this.clase_pregunta_id
      }).subscribe((resultado) => {
        if (resultado.data && resultado.data.length > 0 && resultado.data[0].configuracion_formula)
          this.preguntaLista = [... JSON.parse(resultado.data[0].configuracion_formula)];
      });
  }

  agregarOperador (operator: string) {
    this.cambiarAModulos();

    this.preguntaLista.push({
      value: operator,
      name: operator,
      isOperator: true
    });

    this.isValid = false;
    this.isSyntaxisError = false;
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  close(): void {
    const valor = this.preguntaLista.reduce((acc, el) => {
      return `${acc} ${el.value}`;
    }, "");

    if (this.activeModal) {
      this.activeModal.close({
        clase_pregunta_id: this.clase_pregunta_id,
        pregunta_encuesta_id: this.pregunta_id,
        es_formula: true,
        valor_formula: valor.trim(),
        configuracion_formula: JSON.stringify(this.preguntaLista)
      });
    }
  }

  validate() {
    const valor = this.preguntaLista.reduce((acc, el) => {
      return `${acc} ${el.value}`;
    }, "");

    if (valor.length > 0) {
      this.modalPreguntaFormuladaService
        .createValidate({
          clase_pregunta_id: this.clase_pregunta_id,
          pregunta_encuesta_id: this.pregunta_id,
          valor_formula: valor.trim(),
          es_configuracion_formula: 1
        }).subscribe((resultado) => {
          this.isValid = resultado.result;
          if (resultado.result) this.isSyntaxisError = false;
          else this.isSyntaxisError = true;
        });
    } else this.isValid = true;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim() && !isNaN(Number(value.trim()))) {
      this.cambiarAModulos();

      this.preguntaLista.push({
        value: Number(value.trim()),
        name: value.trim()
      });
    }

    if (input) input.value = '';

    this.preguntaFormuladaCtrl.setValue(null);
    this.isValid = false;
    this.isSyntaxisError = false;
  }

  remove(i: number): void {
    this.preguntaLista.splice(i, 1);
    this.cambiarAModulos();
    this.isValid = false;
    this.isSyntaxisError = false;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const lastValue = (this.preguntaLista.length > 0) ?
      this.preguntaLista[this.preguntaLista.length - 1] : { name:'', value: 1 };
    const lastSecondValue = (this.preguntaLista.length > 1) ?
      this.preguntaLista[this.preguntaLista.length - 2] : { name:'', value: 1 };

    this.preguntaLista.push(event.option.value);

    if (lastSecondValue.value === null) {
      this.preguntaLista.splice(this.preguntaLista.length - 3, 3);
      this.preguntaLista.push({
        name: `<span class="item-mat-chip">${lastSecondValue.name}</span> <span class="item-mat-chip">${lastValue.name}</span> <span class="item-mat-chip">${event.option.value.name}</span>`,
        value: event.option.value.value,
        isOperator: false
      });

      this.preguntaListaTodas = this.modulos;
    }
    else if (lastValue.value === null) this.modalPreguntaFormuladaService
    .getModulosSeccionesPreguntas({
      anio: this.infoPregunta.anio,
      pregunta_id: this.pregunta_id,
      clase_pregunta_id: this.clase_pregunta_id,
      es_formula_o_condicion: true,
      modulo_encuesta_id: lastValue.id,
      seccion_encuesta_id: event.option.value.id,
    }).subscribe((resultado) => {
      if (resultado.data && resultado.data.length > 0) {
        const preguntas = resultado.data.reduce((acc, el) => {
          acc.push({
            id: el.pregunta_encuesta_id,
            name: el.desc_pregunta,
            value: `#${lastValue.id}.${event.option.value.id}.${el.pregunta_encuesta_id}#`,
            isOperator: false
          });
          return acc;
        }, []);

        this.preguntaListaTodas = preguntas;
        this.preguntaListaFiltrada = this.preguntaFormuladaCtrl.valueChanges.pipe(
          startWith(null),
          map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));
      } else this.cambiarAModulos();
    });
    else this.modalPreguntaFormuladaService
      .getModulosSeccionesPreguntas({
        anio: this.infoPregunta.anio,
        pregunta_id: this.pregunta_id,
        clase_pregunta_id: this.clase_pregunta_id,
        es_formula_o_condicion: true,
        modulo_encuesta_id: event.option.value.id
      }).subscribe((resultado) => {
        if (resultado.data && resultado.data.length > 0) {
          const secciones = resultado.data.reduce((acc, el) => {
            acc.push({
              id: el.seccion_encuesta_id,
              name: el.titulo,
              value: null,
              isOperator: false
            });
            return acc;
          }, []);

          this.preguntaListaTodas = secciones;
          this.preguntaListaFiltrada = this.preguntaFormuladaCtrl.valueChanges.pipe(
            startWith(null),
            map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));
        } else this.cambiarAModulos();
      });

    this.preguntaListaFiltrada = this.preguntaFormuladaCtrl.valueChanges.pipe(
      startWith(null),
      map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

    this.preguntaFormuladaInput.nativeElement.value = '';
    this.preguntaFormuladaCtrl.setValue(null);
    this.isValid = false;
    this.isSyntaxisError = false;
  }

  private _filter(value: string): string[] {
    const filterValue = value?.toLowerCase();

    return this.preguntaListaTodas.filter(pregunta => pregunta.name.toLowerCase().indexOf(filterValue) === 0);
  }

  private cambiarAModulos = () => {
    this.preguntaListaTodas = this.modulos;

    this.preguntaListaFiltrada = this.preguntaFormuladaCtrl.valueChanges.pipe(
      startWith(null),
      map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

    this.preguntaLista = this.preguntaLista.reduce((acc, el) => {
      if (el.value !== null) acc.push(el);
      return acc;
    }, []);
  }
}
